import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Theme, LoadIcons, Notifications, UserProvider } from 'components';
import BaseApp from './screens/App/App';
import initGlobalStyles from './assets/css/globalCSS';
import { jsx as ___EmotionJSX } from "@emotion/react";

var MainApp = function MainApp() {
  return ___EmotionJSX(Theme, {
    initGlobalStyles: initGlobalStyles
  }, ___EmotionJSX(Router, null, ___EmotionJSX(Notifications, null), ___EmotionJSX(UserProvider, null, ___EmotionJSX(BaseApp, null)), ___EmotionJSX(LoadIcons, null)));
};

render(___EmotionJSX(MainApp, null), document.getElementById('lendmate-admin-root'));